import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SeoIntentPage.css';

export default function SeoIntentPage({
  title,
  subtitle,
  bullets,
  contentTitle,
  contentBody,
  sections = [],
  faq = [],
  internalLinks = []
}) {
  useEffect(() => {
    if (!faq.length) return undefined;

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faq.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer
        }
      }))
    };

    const tagId = 'seo-intent-faq-jsonld';
    let schemaTag = document.querySelector(`#${tagId}`);
    if (!schemaTag) {
      schemaTag = document.createElement('script');
      schemaTag.setAttribute('id', tagId);
      schemaTag.setAttribute('type', 'application/ld+json');
      document.head.appendChild(schemaTag);
    }

    schemaTag.textContent = JSON.stringify(schema);

    return () => {
      const currentTag = document.querySelector(`#${tagId}`);
      if (currentTag) currentTag.remove();
    };
  }, [faq]);

  return (
    <div className="seo-intent-wrapper">
      <div className="seo-intent-container">
        <header className="seo-intent-hero">
          <h1>{title}</h1>
          <p>{subtitle}</p>
          <Link to="/qrcode-generator" className="seo-intent-cta">Criar QR Code Agora</Link>
        </header>

        <section className="seo-intent-grid">
          {bullets.map((item) => (
            <article className="seo-intent-card" key={item.title}>
              <h2>{item.title}</h2>
              <p>{item.text}</p>
            </article>
          ))}
        </section>

        <section className="seo-intent-content">
          <h2>{contentTitle}</h2>
          <p>{contentBody}</p>
        </section>

        {sections.length > 0 && (
          <section className="seo-intent-sections">
            {sections.map((section) => (
              <article className="seo-intent-section-card" key={section.title}>
                <h2>{section.title}</h2>
                <div className="seo-intent-section-body">
                  {section.topics?.map((topic) => (
                    <div className="seo-intent-topic" key={topic.heading}>
                      <h3>{topic.heading}</h3>
                      <p>{topic.text}</p>
                    </div>
                  ))}
                </div>
              </article>
            ))}
          </section>
        )}

        {faq.length > 0 && (
          <section className="seo-intent-faq">
            <h2>Perguntas frequentes</h2>
            <div className="seo-intent-faq-list">
              {faq.map((item) => (
                <article className="seo-intent-faq-item" key={item.question}>
                  <h3>{item.question}</h3>
                  <p>{item.answer}</p>
                </article>
              ))}
            </div>
          </section>
        )}

        {internalLinks.length > 0 && (
          <section className="seo-intent-internal-links">
            <h2>Veja também</h2>
            <ul>
              {internalLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </section>
        )}
      </div>
    </div>
  );
}
